import type { Id } from '../../../aliases'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import {
  type LookupSiteEncryptionInfo,
  LookupSiteEncryptionInfoSchema,
} from '../../../types/lookupSiteEncryptionInfo'
import {
  type LookupSiteFileHash,
  LookupSiteFileHashSchema,
} from '../../../types/lookupSiteFileHash'

export type LookupSiteResponsePayload = {
  siteId: Id
  encryptionInfo: LookupSiteEncryptionInfo
  currentVersion: string
  urlPrefix: string
  fileHashes?: LookupSiteFileHash[]
  proxyLinkCode?: Id
}

export const LookupSiteResponsePayloadSchema: CborSchema<LookupSiteResponsePayload> =
  defineCborSchema<LookupSiteResponsePayload>({
    siteId: CborField({ key: 0 }),
    encryptionInfo: CborField({ key: 1, type: LookupSiteEncryptionInfoSchema }),
    currentVersion: CborField({ key: 2 }),
    urlPrefix: CborField({ key: 3 }),
    fileHashes: CborField({
      key: 4,
      required: false,
      arrayItemType: LookupSiteFileHashSchema,
    }),
    proxyLinkCode: CborField({ key: 5, required: false }),
  })
